import { Typography } from "@mui/material";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";
import { BRAND_NAME, ROUTES } from "@constants";
import { useHistory } from "react-router-dom";

export const GetMobileLink = () => {
    const { classes } = useStyle();
    const { t } = useTranslation("home");

    const { push } = useHistory();

    return (
        <Typography
            aria-label={t("getMobile", { brand: BRAND_NAME })}
            className={classes.getMobileLink}
            color="primary"
            variant="normal"
            onClick={() => push(ROUTES.MOBILE_PAGE_URL)}
        >
            {t("getMobile", { brand: BRAND_NAME })}
        </Typography>
    );
};
